module.exports = __webpack_public_path__ + "static/media/redir_orange.bda51a0d.svg";